import { render, staticRenderFns } from "./InspectionListIdentifierDialog.vue?vue&type=template&id=602d0d8e&scoped=true&"
import script from "./InspectionListIdentifierDialog.vue?vue&type=script&lang=ts&"
export * from "./InspectionListIdentifierDialog.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionListIdentifierDialog.vue?vue&type=style&index=0&id=602d0d8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602d0d8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
